import React, { Component } from 'react';
import { FormGroup, Input, Button, Badge, Container, Progress } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import c from '../../constants/Colors';
import { data } from '../../constants/Constants';
import { notificacion } from '../../utilitarios/util';
import { ListarEstadosPedido, ListarHistorialPedido, ListarHistorialPedidoTodos, ListarDetallePedido, ListarTrakingPedido } from '../../store/sagas/pedidoApi';
import localStorageCustom from '../../utilitarios/localStorage';
import Spinner from "../reusable/Loader";
import FormFeedback from 'reactstrap/lib/FormFeedback'; 

const CardPedido = ({ pedido, estadoPedido, estado, setDetallePedido, setTracking, colorCard }) => {
 
  return (
    <div className="card_pedido">
      <div className="card-body">
        <div className="status">
          <Badge style={{ backgroundColor: colorCard }}>{pedido.estad}</Badge>
          <span className="precio" style={{ color: colorCard }}>{pedido.sWaers} {pedido.impor.toLocaleString("en-US", { minimumFractionDigits: 2 })}</span>
        </div>
        {(estadoPedido == data.EstadoPedido.PorPagar) ?
          <span className="paragraph-3" style={{ color: c.grisMedio }}>Fecha máxima de pago {pedido.fechaPedido}</span>
          :
          <span className="paragraph-3" style={{ color: c.grisMedio }}>Fecha de Pedido {pedido.fechaPedido}</span>
        }
        <h6 className="paragraph-2 bold my-1" style={{ color: c.azulClaro }}>Pedido a {pedido.street}</h6>
        <span className="paragraph-3" style={{ color: c.azulClaro }}>{pedido.vbeln}</span>
      </div>
      <div className="card-footer" style={{ backgroundColor: colorCard }}>
        <a href="#"  
          onClick={(e) => { e.preventDefault(); setTracking(pedido.vbeln, pedido.tipod, pedido.serie, pedido.numer) }}>
          Tracking<SvgAssets icon="icon-right" fill="#fff" />
        </a>
        <a href="#"
          onClick={(e) => { e.preventDefault(); setDetallePedido(pedido.vbeln, pedido.tipod, pedido.serie, pedido.numer, estado) }}>
          Ver detalle<SvgAssets icon="icon-right" fill="#fff" />
        </a>
      </div>
    </div>
  )
}

export class HistorialPedidos extends Component {
  static displayName = HistorialPedidos.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      tabIndex: 0,
      dealer: {},
      linea: {},
      correoElectronico: null,
      vkorg: null,
      estados: [],
      historialPedidos: [],
      historialPedidosFiltrados: [],
      Tipo: 'H',
      estadoPedido: null,
      search: '',
      errorCodigo: false,
      showAlert: false,
      alertTitulo: "",
      alertMensaje: "",
      isEmpty: false,
    };
  }

  searchPedido = (e) => {
    let text = e.currentTarget.value;
    this.setState({ loading: true });
    if (text) {
      let textData = text.toUpperCase();
      let newData = this.state.historialPedidos.filter(function (item) {
        const itemData = item.vbeln.toUpperCase();
        if (itemData.indexOf(textData) > -1) return item;
      });
      this.setState({ historialPedidosFiltrados: newData, search: text, loading: false });
    } else {
      this.setState({ historialPedidosFiltrados: this.state.historialPedidos, search: '', loading: false });
    }
  }

  validEstado() {
    if (this.props.location.state != null) {
      let estado = this.props.location.state.estado;
      if (estado != null) this.setState({ estado: estado }, () => {
        this.props.history.replace();
      });
    }
  }

  checkParams() {
    this.validEstado();
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    let data = localStorageCustom.prototype.getUsuario();
    try {
      this.checkParams();
      this.setState(
        { dealer: data.dealer, linea: data.linea, asociado: data.asociado, loading: false },
        () => this.postListarEstadosPedido(data.dealer.codcliente, data.dealer.correoElectronico));
    }
    catch (error) {
      this.setState({ loading: false }, async () => {
        error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
        notificacion("Historial", error.message ?? null);
      });
    };
  }

  postListarEstadosPedido = (cliente, correo) => {
    this.setState({ loading: true });
    console.log(cliente, correo, this.state.linea.vkorg, this.state.Tipo);
    ListarEstadosPedido(cliente, correo, this.state.linea.vkorg, this.state.Tipo)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            estados: result.dto.listaEstados,
          });
          if (result.dto.listaEstados.length > 0) {
            let index = 0;
            let estado = result.dto.listaEstados[index].estad;

            if (this.state.estado != null) {
              debugger;
              index = result.dto.listaEstados.findIndex(x => x.estad == this.state.estado.codigo);
              estado = result.dto.listaEstados[index].estad;
              this.setState({ estado: null });
            }
            this.setTabIndex(estado, index);
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          notificacion("Estados pedidos", error.message ?? null);
        });
      });
  }

  postListarHistorialPedido = async (VKorg, Estado, CodigoDealer, CorreoElectronicoDealer, tipo) => {
    this.setState({ loading: true });
    ListarHistorialPedido(VKorg, Estado, CodigoDealer, CorreoElectronicoDealer, tipo)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            historialPedidos: result.dto.historialPedido,
            historialPedidosFiltrados: result.dto.historialPedido,
            isEmpty: false,
            errorCodigo: false
          });
        } else {
          this.setState({ isEmpty: true, errorCodigo: false })
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({
          loading: false,
          historialPedidos: [],
          historialPedidosFiltrados: [],
          errorCodigo: false
        });
      });
  }

  postListarHistorialPedidoTodos = async (VKorg, Pedido, CodigoDealer, CorreoElectronicoDealer, tipo) => {
    this.setState({ loading: true });
    ListarHistorialPedidoTodos(VKorg, Pedido, CodigoDealer, CorreoElectronicoDealer, tipo)
      .then(result => {
        if (result.mo.type == "success") {
          console.log("historialPedidos==>", result.dto.historialPedido);
          this.setState({
            isEmpty: false,
            errorCodigo: false,
            historialPedidos: result.dto.historialPedido,
            historialPedidosFiltrados: result.dto.historialPedido,
            loading: false
          });
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({
          loading: false,
          historialPedidos: [],
          historialPedidosFiltrados: []
        });
      });
  }

  render() {
    const { search, errorCodigo, tabIndex, estados, historialPedidos, historialPedidosFiltrados, loading, estadoPedido, isEmpty } = this.state;
    const navigation = this.props.navigation;
    
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Historial de pedidos</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li>Pedidos</li>
              <li><Link to='/historial-pedidos' style={{ pointerEvents: 'none' }}>Historial de pedidos</Link></li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile">
            <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>Historial de Pedidos
          </h6>
          <div className="pills-scroll-container">
            {
              estados.map((pill, index) => {
                let backgroundColorPill = this.getBackGroundColorForTab(pill.estad, data.EstadoPedido);
                let colorPill = this.getColorForTab(pill.estad, data.EstadoPedido);
                return (<button key={index + 1}
                  className={tabIndex === index ? 'active' : ''} style={tabIndex === index ? { backgroundColor: backgroundColorPill, color: colorPill } : {}}
                  onClick={() => this.setTabIndex(pill.estad, index)}
                >{pill.nomEstad}
                </button>
                )
              })
            }
          </div>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <div className="buscador_historial">
              <FormGroup className="icon mb-4">
                <Input className="" type='text' placeholder="N° de Pedido"
                  value={search}
                  onChange={(text) => this.searchPedido(text)}
                />
                <Button color="link" className="btn-icon"
                  type="button"
                  onClick={() => { this.IrBuscar() }}
                >
                  <SvgAssets icon='icon-lupa' fill={c.azulClaro} />
                </Button>
                {(errorCodigo) ? <FormFeedback>Por favor ingrese un código (al menos 5 caracteres)</FormFeedback> : null}
              </FormGroup>
              <h6 className="paragraph-2 text-left light mb-4" style={{ color: c.grisMedio }}>Resultados ({(historialPedidosFiltrados || []).length})</h6>
            </div>
            {
              isEmpty ?
                <div>
                  <div className="empty">
                    <SvgAssets icon="icon-folder" fill={c.celeste} />
                    <h6 className="paragraph-1 text-center" style={{ color: c.celeste }}>{tabIndex == 8 ? 'Mira tu pedido!' : 'No tienes pedidos'}</h6>
                    {tabIndex == 8 ? <p className="paragraph-1 text-center" style={{ color: c.grisMedio }}>Conoce el <strong>estado</strong> detallado de tu pedido ingresando el <strong>número de pedido</strong> en el buscador</p>
                      : <p className="paragraph-1 text-center" style={{ color: c.grisMedio }}>Aún no cuentas con pedidos generados, aquí encontrarás todos los pedidos realizados.</p>
                    }
                  </div>
                  <div className="text-center mt-2 mobile">
                    <Link to="/generar-pedido" style={{ textDecoration: 'none' }}>
                      <button className='btn-block' style={{ backgroundColor: c.naranja }}>realizar pedido</button>
                    </Link>
                  </div>
                </div>
                :
                <div className="cards-wrap">
                  {(historialPedidosFiltrados || []).map((pedido, index) => {
                    let estado = (estados || []).find(x => x.estad == pedido.codEstad);
                    let colorCard = this.getBackGroundColorForTab(pedido.codEstad, data.EstadoPedido);
                    return (
                      <CardPedido pedido={pedido} key={index} estadoPedido={estadoPedido} estado={estado} setDetallePedido={this.setDetallePedidoTracking} setTracking={this.setTracking} colorCard={colorCard} />
                    )
                  })}
                </div>

            }
          </div>
          {isEmpty ?
            // <div className="text-center mt-5 desktop" style={{ justifyContent: 'center' }} ref={(el) => { if (el) el.style.setProperty("display", "flex", "important"); }}>
            <div className="text-center mt-5 desktop">
              <Link to="/generar-pedido" style={{ textDecoration: 'none' }}>
                <button className='btn-block'>realizar pedido</button>
              </Link>
            </div> : null
          }
        </Container>
      </div>
    );
  }

  addPedidos = async () => {
    // this.props.navigation.navigate('GenerarPedido');
    this.props.navigation.navigate('GenerarPedidoStack');
  }
  setTabIndex = (estado, index) => {
    this.setState({ tabIndex: index, loading: false, estadoPedido: estado, search: '' });

    this.postListarHistorialPedido(this.state.linea.vkorg, estado,
      this.state.dealer.codcliente,
      this.state.dealer.correoElectronico,
      this.state.Tipo);

  }

  IrBuscar = () => {
    if (this.state.estadoPedido == "0") {
      if (this.state.search == "" || this.state.search.length < 5) {
        this.setState({
          errorCodigo: true
        });
      } else {
        this.postListarHistorialPedidoTodos(this.state.linea.vkorg, this.state.search,
          this.state.dealer.codcliente,
          this.state.dealer.correoElectronico,
          this.state.Tipo);
      }
    }
  }

  setDetallePedido = (kunnr) => {

    this.setState({ loading: true });
    ListarDetallePedido(kunnr, this.state.dealer.codcliente, this.state.dealer.correoElectronico)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false
          });
          this.props.history.push({
            pathname: '/detalle-pedido',
            state: {
              detallePedido: result.dto.detallePedido,
              detalle: result.dto.detallePedido.detalle, dealer: this.state.dealer, linea: this.state.linea
            }
          });
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({
          loading: false
        });
      });

  }

  setDetallePedidoTracking = async (kunnr, Tipo, serie, numer, estado) => {
    this.setState({ loading: true });
    let resultDetalle = await ListarDetallePedido(kunnr, this.state.dealer.codcliente, this.state.dealer.correoElectronico);
    let resultTracking = await ListarTrakingPedido(kunnr, this.state.dealer.codcliente, this.state.dealer.correoElectronico, Tipo, serie, numer, this.state.linea.cdvped)

    if (resultDetalle.mo.type == "success" && resultTracking.mo.type == "success") {
      this.setState({
        loading: false
      });
      this.props.history.push({
        pathname: '/detalle-pedido',
        state: {
          detallePedido: resultDetalle.dto.detallePedido,
          detalle: resultDetalle.dto.detallePedido.detalle,
          trackingPedido: resultTracking.dto.trakingPedido,
          trakingDetalle: resultTracking.dto.trakingPedido.trakingDetalle,
          dealer: this.state.dealer,
          linea: this.state.linea,
          estado: estado
        }
      });
    } else {
      this.setState({
        loading: false
      });
    }
  }

  setTracking = (kunnr, Tipo, serie, numer) => {
    this.setState({ loading: true });
    ListarTrakingPedido(kunnr, this.state.dealer.codcliente,
      this.state.dealer.correoElectronico, Tipo, serie, numer,
      this.state.linea.cdvped)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false });
          this.props.history.push({
            pathname: '/tracking',
            state: {
              trackingPedido: result.dto.trakingPedido,
              trakingDetalle: result.dto.trakingPedido.trakingDetalle
            }
          });
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({
          loading: false
        });
      });

  }

  getBackGroundColorForTab = (estado, data) => {
    switch (estado) {
      case data.PorPagar:
        return c.naranja;
      case data.Entregado:
        return c.verde;
      case data.Expirado:
        return c.rojoClaro;
      case data.EnPreparacion:
        return c.morado;
      case data.Facturado:
        return c.amarillo;
      case data.Pagado:
        return c.azul;
      case data.Despachado:
        return c.celeste;
      case data.Anulado:
        return c.grisMedio;
      default:
        return c.azulClaro;
    }
  }

  getColorForTab = (estado, data) => {
    switch (estado) {
      case data.PorPagar:
      case data.Entregado:
      case data.Expirado:
      case data.EnPreparacion:
      case data.Facturado:
      case data.Pagado:
      case data.Despachado:
      case data.Anulado:
      case data.Procesado:
      case data.Anulado:
      case data.Todos:
        return "#fff";
      default:
        return c.azulClaro;
    }
  }
}
